<div class="d-flex rounded-2 background-light-gray p-2 gap-2 pointer pointer-hover-blue">
    <app-bluetooth-svg [status]="status()" class="img-fluid img-max px-2"></app-bluetooth-svg>
    <div class="d-flex flex-column justify-content-center">
        <div class="fw-bold text-truncate">{{ deviceId() | slice:-5 }}</div>
        <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
        @if (batteryVoltage() !== undefined || rssiColor() !== undefined) {
            <div class="d-flex gap-2">
                @if (batteryVoltage() !== undefined) {
                    <div class="d-flex gap-1">
                        <span class="{{ batterLevelColor() }} text-truncate"><i class="{{ batteryIcon() }}"></i></span>
                        <div class="{{ batterLevelColor() }}">{{ batteryVoltage() | number: '1.0-2' }}V</div>
                    </div>
                }
                @if (batteryVoltage() !== undefined && rssiColor() !== undefined) {
                    |
                }
                @if (rssiColor() !== undefined) {
                    <span class="rssi {{ rssiColor() }} text-truncate"><i class="fa-solid fa-signal"></i></span>
                }
            </div>
        }
    </div>
</div>
